import { VerifyInvitationType } from "@@types/IUser";
import { getIpv6 } from "@services/getIpv6";
import {
  createPassword,
  fetchMe,
  resetPassword,
  sendRecoverPasswordEmail,
  updateFormCompleted,
  verifyInvitation,
} from "@services/http/user";
import { useMutation, useQuery } from "@tanstack/react-query";
import { parseCookies } from "nookies";
import { useUser } from "@contexts/user/UserContext";

export function useFetchMe() {
  const { user, isLoading, isFetching, refetch } = useUser();

  return {
    data: user,
    isLoading,
    isFetching,
    refetch,
    user,
  };
}

export function useFetchMeFocus(refetchOnFocus: boolean) {
  const { user, refetch } = useUser();

  return {
    data: user,
    refetch,
  };
}

export function useResetPassword() {
  return useMutation((resetPasswordForm: any) => {
    return resetPassword(resetPasswordForm);
  });
}

export function useCreatePassword() {
  return useMutation((createPasswordForm: any) => {
    return createPassword(createPasswordForm);
  });
}

export function useSendRecoverPasswordEmail() {
  return useMutation((sendEmail: { email: string }) => {
    return sendRecoverPasswordEmail(sendEmail);
  });
}

export function useCheckInviteValidity() {
  return useMutation((data: VerifyInvitationType) => {
    return verifyInvitation({ inviteCode: data.inviteCode });
  });
}

export function useUpdateFormCompleted() {
  return useMutation((data: { isFormCompleted: boolean }) => {
    return updateFormCompleted(data);
  });
}

export function useGetIPv6() {
  return useQuery(["ipv6"], () => getIpv6(), {
    enabled: true,
    staleTime: Infinity,
    retry: false,
  });
}
